export default __webpack_public_path__ + "static/media/SF-video-for-FB-june.32982708.mp4";